import Vue from "vue";
import TranslationService from "../../services/TranslationService";
const NotificationService = require("../../services/NotificationService");
const ApiService = require("../../services/ApiService");

export default Vue.component("order-history-list-item", {

    props:
    {
        template:
        {
            type: String,
            default: "#vue-order-history-list-item"
        },
        orderDetailsTemplate:
        {
            type: String,
            default: "Ceres::MyAccount.Partials.OrderHistoryListItemDetails"
        },
        order:
        {
            type: Object,
            required: true
        },
        allowPaymentProviderChange:
        {
            type: Boolean,
            default: true
        },
        allowReturn:
        {
            type: Boolean,
            default: true
        }
    },

    data()
    {
        return {
            waiting: false,
            isDataLoaded: false,
            showAllOrderItems: false,
            loadbasket:false
        };
    },

    methods:
    {
        buyAgain(orderId)
        {
            const _self = this;

            _self.loadbasket = true;
            $.ajax({
                type: "GET",
                url: "/"+App.language+"/orderitems/"+orderId+"/",
                dataType: "json",
                success: function(data)
                {
                    const items =
                        {
                            items:data
                        };

                    $.ajax(
                        {
                            type: "POST",
                            url: "/"+App.language+"/cartsave/addtobasket/",
                            data: items,
                            success: function(data)
                            {
                                for ( let i = 0; i < data.length; i++)
                                {
                                    if (i === data.length - 1)
                                    {
                                        _self.$store.commit("setBasketItems", data[i].basketItems);
                                        _self.$store.commit("setBasket", data[i].basket);
                                        NotificationService.success(JSON.parse($("[data-translation=\"YbbaCartSave::Template\"]")[0].innerHTML).notesArtikelhinzugefuegt).closeAfter(1500);
                                        _self.loadbasket = false;
                                    }
                                }
                            },
                            error: function(error)
                            {
                                console.log("error", error);
                                _self.loadbasket = false;
                            }
                        });
                },
                error: function(error)
                {
                    console.log("error", error);
                    _self.loadbasket = false;
                }
            });
        },
        loadOrderDetailTemplate()
        {
            if (!this.waiting && !this.isDataLoaded)
            {
                this.waiting = true;

                const testing = window.ceresEnv !== "testing" ? "" : "&env=testing";

                ApiService
                    .get("/rest/io/order/template?template=" + this.orderDetailsTemplate + "&orderId=" + this.order.id + testing)
                    .done(orderDetails =>
                    {
                        const compiled = Vue.compile(orderDetails);
                        const component = new Vue({
                            data: {
                                showAllOrderItems: this.showAllOrderItems,
                                allowPaymentProviderChange: this.allowPaymentProviderChange,
                                allowReturn: this.allowReturn
                            },
                            store: window.ceresStore,
                            render: compiled.render,
                            staticRenderFns: compiled.staticRenderFns
                        });

                        component.$mount(this.$refs.orderDetailsContainer);

                        this.isDataLoaded = true;
                    })
                    .always(() =>
                    {
                        this.waiting = true;
                    });
            }
        },

        getWarrantyTooltip(referenceOrderId)
        {
            return TranslationService.translate("Ceres::Template.orderHistoryWarranty", { id: referenceOrderId });
        }
    }
});
